import { useEffect } from "react";

export default function Ticket({ invoice, onAfterPrint }) {
  useEffect(() => {
    if (!invoice) return;

    const timer = setTimeout(async () => {
      try {
        const saleId = invoice.id;
        const token = localStorage.getItem("token");

        // Backend generates the PDF and returns it as a blob
        const url = `https://altivawebusa.com/BACK/public/api/print/ticket/${saleId}`;

        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error("Error generating ticket PDF");

        const blob = await response.blob();
        const pdfUrl = URL.createObjectURL(blob);

        // Print using a hidden iframe, no new window
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = pdfUrl;
        document.body.appendChild(iframe);
        iframe.onload = () => {
          iframe.contentWindow.print();
          setTimeout(() => {
            document.body.removeChild(iframe);
            URL.revokeObjectURL(pdfUrl);
          }, 2000);
        };
      } catch (err) {
        console.error("Error generating ticket PDF:", err);
      }

      if (onAfterPrint) onAfterPrint();
    }, 500);

    return () => clearTimeout(timer);
  }, [invoice, onAfterPrint]);

  return null;
}